<template>
  <b-container
    v-if="canRender"
    class="p-0 d-flex flex-column"
    fluid
  >

    <BImg
      :src="Logo"
      width="280"
      class="my-2 d-block mx-auto"
    />

    <b-row class="container-select-card w-100 px-2">
      <b-col
        v-for="item, index in data"
        :key="index"
        md="4"
      >
        <b-card
          class="select-card"
          @click="onClick({
            veripagId: item.veripag_id,
            name: item.name
          })"
        >
          <div
            style="gap: 12px"
            class="text-center d-flex flex-column"
          >
            <h4> {{ item.name }} </h4>
            <h6> {{ item.tax_id | tax_id }}</h6>
            <h6> {{ item.veripag_id }}</h6>
          </div>
        </b-card>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import {
  BRow, BCol, BCard, BImg, BContainer,
} from 'bootstrap-vue'

import Logo from '@/assets/images/logo/logo.svg'

import MerchantService from '@/service/merchant'

import { callLoading } from '@/service/utilities/utilities'
import { getHomeRoute } from '@/utils/home-route'

export default {
  components: {
    BRow, BCol, BCard, BImg, BContainer,
  },

  data() {
    return {
      Logo,
      data: [],
      canRender: false,
    }
  },

  async mounted() {
    callLoading(true)
    const merchant = await new MerchantService().getChildren()
    if (merchant.merchants.length === 1) {
      this.onClick({
        veripagId: merchant.merchants[0].veripag_id,
        name: merchant.merchants[0].name,
      })
    } else {
      this.canRender = true
    }
    this.data = merchant.merchants
    callLoading(false)
  },

  methods: {
    onClick(input) {
      const merchantId = Number(input.veripagId)
      if (!Number.isInteger(merchantId) || merchantId <= 0) return

      sessionStorage.setItem('veripagID', merchantId.toString())
      this.$store.dispatch('user/fetch')
      this.$router.push(getHomeRoute())
    },
  },
}

</script>

<style>
.select-card{
  transition: background-color .1s, all .3s;
  cursor: pointer;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}
.container-select-card {
  animation: select-card 1s;
}
.select-card:hover {
  background-color: rgb(243 112 33);
  color: white;
  width: 99%;
  z-index: 9;
  transform: scale(1.1);
  animation: selected-card .8s;
}

.select-card:hover h4, .select-card:hover h6 {
  color: white;
}
@keyframes select-card {
  from {transform: scale(1.1); opacity: .1;}
  to {opacity: 1;}
}

@keyframes selected-card {
  0% { transform: scale(1);  width: 95%; }
  80% { transform: scale(1);  width: 95%; }
  100% { width: 99%; transform: scale(1.1); }
}
</style>
